import * as React from 'react';
import styled, { css } from 'styled-components';

import { FooterLogo } from './Logo';

export const Footer: React.FC = () => {
  return (
    <StyledFooter className="footer">
      <div
        className="logo-link"
        onClick={() => {
          if (typeof window !== 'undefined') {
            window.location.href = '/';
          }
        }}
      >
        <FooterLogo className="logo" />
      </div>
      <StyledFooterNavContainer className="desktop">
        <StyledFooterNav>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/verdivurdering-selge-eiendom">
            Selge eiendom
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/kjope-bolig">
            Kjøpe eiendom
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/selge-fritidseiendom-hytte">
            Fritidseiendom
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/kontorer">
            Kontor / megler
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/nybygg">
            Nybygg
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/styling-og-klargjoring">
            Styling og klargjøring
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/kjope-eiendom">
            KJØP
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/boligbytte-selge-eiendom">
            Boligbytte
          </StyledFooterLinkAnchor>
        </StyledFooterNav>
        <StyledFooterNav>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/kampanje/kvadrat">
            Kvadrat
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/kampanje/presisjon">
            Digital boligannonsering
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/leveransebeskrivelse-selge-bolig">
            Vår leveranse
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/content/selge-bolig-tips-rad">
            Tips og råd ved salg
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/boligsok">
            PrivatMegleren Eiendomssøk
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/finansiering-boliglan">
            Finansiering
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/om-oss">
            Om oss
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/personvern">
            Personvern
          </StyledFooterLinkAnchor>
        </StyledFooterNav>
      </StyledFooterNavContainer>
      <StyledFooterNavContainer className="mobile">
        <StyledFooterNav>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/verdivurdering-selge-eiendom">
            Selge eiendom
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/kjope-bolig">
            Kjøpe eiendom
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/selge-fritidseiendom-hytte">
            Fritidseiendom
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/kontorer">
            Kontor / megler
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/nybygg">
            Nybygg
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/styling-og-klargjoring">
            Styling og klargjøring
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/kjope-eiendom">
            KJØP
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/boligbytte-selge-eiendom">
            Boligbytte
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/kampanje/kvadrat">
            Kvadrat
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/kampanje/presisjon">
            Digital boligannonsering
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/leveransebeskrivelse-selge-bolig">
            Vår leveranse
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/content/selge-bolig-tips-rad">
            Tips og råd ved salg
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/boligsok">
            PM Eiendomssøk
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/finansiering-boliglan">
            Finansiering
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/om-oss">
            Om oss
          </StyledFooterLinkAnchor>
          <StyledFooterLinkAnchor href="https://privatmegleren.no/personvern">
            Personvern
          </StyledFooterLinkAnchor>
        </StyledFooterNav>
      </StyledFooterNavContainer>
      <StyledFooterNavContainer className="w290">
        <StyledFooterNav>
          <StyledFooterLinkAnchor
            className="small-footer-link"
            href="https://www.facebook.com/pmnorge/"
          >
            facebook
          </StyledFooterLinkAnchor>
        </StyledFooterNav>
        <StyledFooterNav>
          <StyledFooterLinkAnchor
            className="small-footer-link"
            href="https://www.instagram.com/privatmegleren_norge/?hl=nb"
          >
            instagram
          </StyledFooterLinkAnchor>
        </StyledFooterNav>
      </StyledFooterNavContainer>
      <StyledFooterLinkAnchor
        className="policy-link"
        as="a"
        href="https://privatmegleren.no/personvern"
      >
        Personvern og cookies
      </StyledFooterLinkAnchor>
    </StyledFooter>
  );
};

export default Footer;

const StyledFooter = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 3rem 1.5rem;
  margin-top: 3rem;
  width: 100%;
  background: #171719;
  border-top: 1px solid rgb(36, 37, 37);
  position: relative;
  z-index: 1;

  .logo {
    margin-bottom: 2.5rem;
  }

  .logo-link {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StyledFooterNavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 30rem;
  margin: 0 auto;

  &.w290 {
    width: 18.125rem;
  }

  &.desktop {
    display: flex;
  }

  &.mobile {
    display: none;
  }

  @media all and (max-width: 650px) {
    width: 100%;
    flex-flow: column;

    &.desktop {
      display: none;
    }

    &.mobile {
      display: flex;
    }
  }
`;

const StyledFooterNav = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-right: 1.25rem;

  @media all and (max-width: 650px) {
    margin-right: 0;
  }
`;

const StyledBaseFooterLink = css`
  padding: 0 0 0.625rem 0;
  text-decoration: none;
  font-size: 1.125rem;
  font-weight: 300;
  color: white;

  &:focus {
    outline: none;
  }

  &:hover {
    color: #e7cfa7;
  }

  &.small-footer-link {
    padding: 1.25rem 0 0 0.625rem;
    font-size: 1rem;
  }

  &.policy-link {
    margin-top: 1.875rem;
    font-size: 1rem;
  }
`;

const StyledFooterLinkAnchor = styled.a`
  ${StyledBaseFooterLink}

  &.developed-by {
    font-size: 14px;
    color: rgb(100, 100, 100);
  }
`;
